import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { UNDEF, UNDERSCORE, isInterActiveEvt } from '../lib';
import { triggerEvent, removeListener, getListeners, addListener } from '../event-api';
import schedular, { priorityList } from '../schedular';

var idCounterStore = {},
    asyncDrawOptions = {
  executionDelay: 16
},
    _mapSubFnBackward = function _mapSubFnBackward(a, b) {
  if (a && a.hasOwnProperty && b && b.call) {
    var c, d, e;

    for (c in a) {
      if (a.hasOwnProperty(c)) if (d = a[c], d instanceof Array) for (e = d.length - 1; 0 <= e; e--) {
        b(d[e], c, e);
      } else b(d, c);
    }
  }
},
    _mapSubFnForward = function _mapSubFnForward(a, b) {
  if (a && a.hasOwnProperty && b && b.call) {
    var c, d, e, f;

    for (c in a) {
      if (a.hasOwnProperty(c)) if (d = a[c], d instanceof Array) for (f = d.length, e = 0; e < f; e++) {
        b(d[e], c, e);
      } else b(d, c);
    }
  }
},
    addAllEventsOnGraphic = function addAllEventsOnGraphic(a, b, c) {
  var d, e;
  if (b && b.hasOwnProperty) for (d in b) {
    b.hasOwnProperty(d) && (e = getListeners(d, c), e && 1 <= e.length && a && a.on(d, b[d]));
  }
},
    removeAllEventsFromGraphic = function removeAllEventsFromGraphic(a, b) {
  var c, d;
  if (b && b.hasOwnProperty) for (c in b) {
    b.hasOwnProperty(c) && (d = getListeners(c, this), d && 1 <= d.length && a && a.off(c, b[c]));
  }
};

var ComponentBase =
/*#__PURE__*/
function () {
  function ComponentBase() {
    _classCallCheck(this, ComponentBase);

    var a = this;
    a.config = {}, a._jobList = {}, a._env = {}, a._extListeners = {}, a._state = {}, a._factories = [], a._factoriyNames = {}, a._graphics = {}, a.__drawJob = function () {
      a.updateVisual();
    }, a.__remove = function () {
      a.getState('removed') && a._dispose();
    }, a._setRemoveAnim = function (b, c) {
      var d = a.getFromEnv('animationManager');
      d.setAnimation({
        el: b,
        component: a,
        label: c,
        props: b.__props
      }), a._setRemoveAnim = function (b, c) {
        d.setAnimation({
          el: b,
          component: a,
          label: c,
          props: b.__props
        });
      };
    }, a.__instantRemoveFn = function (b) {
      var c = a.getFromEnv('animationManager');
      c.removeElement(b, !0), a.__instantRemoveFn = function (a) {
        return c.removeElement(a, !0);
      };
    };
  }

  _createClass(ComponentBase, [{
    key: "configure",
    value: function configure(a) {
      this.preConfigure(a), this.configureAttributes(a), this.postConfigure(a), this.invokeFactories();
    }
  }, {
    key: "preConfigure",
    value: function preConfigure(a) {
      this.fireEvent('preconfigure', a);
    }
  }, {
    key: "configureAttributes",
    value: function configureAttributes() {
      return this;
    }
  }, {
    key: "postConfigure",
    value: function postConfigure(a) {
      this.fireEvent('postconfigure', a);
    }
  }, {
    key: "prepareAttributes",
    value: function prepareAttributes() {
      var a = this;
      a.fireEvent('beforeattributeprepared'), a.allocatePosition && a.allocatePosition(), a._mapChildren(function (a) {
        a.prepareAttributes && a.prepareAttributes();
      }), a.fireEvent('attributeprepared');
    }
  }, {
    key: "setDefaults",
    value: function setDefaults() {
      this.__setDefaultConfig(), this._mapChildren(function (a) {
        return a.setDefaults();
      });
    }
  }, {
    key: "__setDefaultConfig",
    value: function __setDefaultConfig() {
      return this;
    }
  }, {
    key: "setData",
    value: function setData(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var c,
          d = this,
          e = d.getLinkedParent();
      d.asyncDraw(), b || this.setDefaults(), d.configure && d.configure(a), c = d.getState('change-info'), c && c.hasNoExternalEffect || e && e.childChange && e.childChange(c, d.getId());
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'generic';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'generic';
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id || this.setId(), this._id;
    }
  }, {
    key: "setId",
    value: function setId(a) {
      var b;
      a === UNDEF && (b = this.getType() + UNDERSCORE + this.getName(), !idCounterStore[b] && (idCounterStore[b] = 1), a = b + UNDERSCORE + idCounterStore[b], idCounterStore[b] += 1), this._id = a;
    }
  }, {
    key: "iterateComponents",
    value: function iterateComponents(a) {
      var b = function b(c, d, e) {
        var f = a(c, d, e);
        !1 !== f && c._mapChildren && c._mapChildren(b);
      };

      this._mapChildren(b);
    }
  }, {
    key: "getFromEnv",
    value: function getFromEnv(a) {
      return a ? this._env[a] : this._env;
    }
  }, {
    key: "addToEnv",
    value: function addToEnv(a, b) {
      a && (this._env[a] = b);
    }
  }, {
    key: "deleteFromEnv",
    value: function deleteFromEnv(a) {
      delete this._env[a];
    }
  }, {
    key: "_updateParentEnv",
    value: function _updateParentEnv() {
      var a,
          b,
          c,
          d,
          e = this.getLinkedParent(),
          f = this._env;

      if (e) {
        if (a = e.getFromEnv(), b = function b() {}, b.prototype = a, b.prototype.constructor = b, c = new b(), f) for (d in f) {
          f.hasOwnProperty(d) && (c[d] = f[d]);
        }
        this._env = c, this._mapChildren(function (a) {
          a._updateParentEnv && a._updateParentEnv();
        });
      }
    }
  }, {
    key: "addJob",
    value: function addJob(a, b, c, d) {
      var e = this;
      e._jobList[a] = e._jobList[a] ? schedular.updateJob(e._jobList[a], b, c, d) : schedular.addJob(b, c, d);
    }
  }, {
    key: "removeJob",
    value: function removeJob(a) {
      var b = this._jobList[a];
      b && (schedular.removeJob(b), delete this._jobList[a]);
    }
  }, {
    key: "removeAllJobs",
    value: function removeAllJobs() {
      var a,
          b = this._jobList;

      for (a in b) {
        b.hasOwnProperty(a) && (schedular.removeJob(b[a]), delete b[name]);
      }
    }
  }, {
    key: "asyncDraw",
    value: function asyncDraw() {
      var a = this;
      a.addJob('draw', a.__drawJob, priorityList && priorityList.draw, asyncDrawOptions);
    }
  }, {
    key: "syncDraw",
    value: function syncDraw() {
      var a = this;
      a.fireEvent('predraw'), a.removeJob('draw'), a.getState('removed') ? a.removingDraw() : a.draw && a.draw(), a.addExtEventListener('animationComplete', a.__remove, a.getFromEnv('animationManager')), a.childrenSyncDraw(), a.setState('dirty', !1), a.setState('parentChanged', !1), a.addJob('draw-complete', function () {
        a.fireEvent('drawn');
      }, priorityList.instant);
    }
  }, {
    key: "updateVisual",
    value: function updateVisual() {
      var a = this;
      a.fireEvent('beforevisualupdate'), a.removeJob('visualupdate'), a.manageSpace && a.manageSpace(), a.prepareAttributes(), a.syncDraw(), a.fireEvent('visualupdated');
    }
  }, {
    key: "childrenSyncDraw",
    value: function childrenSyncDraw() {
      this._mapChildren(function (a) {
        a && a.draw && a.syncDraw();
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(a, b, c) {
      var d,
          f = this;
      return !!(a && a.toLowerCase && (a = a.toLowerCase(), addListener(a, b, f, c))) && (isInterActiveEvt(a) && (d = getListeners(a, f), d && 1 === d.length) ? (f._middleListeners || (f._middleListeners = {}), f._middleListeners[a] || (f._middleListeners[a] = function (b) {
        f.fireEvent(a, UNDEF, UNDEF, UNDEF, b);
      }), !0) : b);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(a, b) {
      var c,
          d = this;
      if (a && a.toLowerCase && (a = a.toLowerCase(), removeListener(a, b, d), isInterActiveEvt(a) && (c = getListeners(a, d), c && 0 === c.length && d._middleListeners && d._middleListeners[a]))) return !0;
    }
  }, {
    key: "fireEvent",
    value: function fireEvent(a, b, c, d, e) {
      triggerEvent(a, this, b, e, c, d);
    }
  }, {
    key: "addExtEventListener",
    value: function addExtEventListener(a, b, c) {
      var d = this;
      return !!(c && c.addEventListener && c.addEventListener(a, b)) && (d._extListeners[a] || (d._extListeners[a] = []), d._extListeners[a].push({
        fn: b,
        component: c
      }), b);
    }
  }, {
    key: "removeExtEventListener",
    value: function removeExtEventListener(a, b, c) {
      var d,
          e,
          f,
          g = this;
      if (c && c.addEventListener && g._extListeners && g._extListeners[a]) for (f = g._extListeners[a], e = f.length, d = e - 1; 0 <= d; d -= 1) {
        if (f[d] && f[d].fn === b && f[d].component === c) return c.removeEventListener(a, b), void f.splice(d, 1);
      }
    }
  }, {
    key: "_setLinkedParent",
    value: function _setLinkedParent(a) {
      var b = this._linkedParent;
      this._linkedParent = a, b !== a && (this.setState('parentChanged', !0), b && this.fireEvent('parentdetached', {
        oldParent: b
      }), a && this.fireEvent('parentAttached', {
        newParent: a
      })), this._updateParentEnv && this._updateParentEnv();
    }
  }, {
    key: "getLinkedParent",
    value: function getLinkedParent() {
      return this._linkedParent;
    }
  }, {
    key: "setLinkedItem",
    value: function setLinkedItem(a, b) {
      this.linkedItems || (this.linkedItems = {}), (a !== UNDEF || b !== UNDEF) && (this.linkedItems[a] = b);
    }
  }, {
    key: "getLinkedItem",
    value: function getLinkedItem(a) {
      if (this.linkedItems) return a === UNDEF ? this.linkedItems : this.linkedItems[a];
    }
  }, {
    key: "removeLinkedItem",
    value: function removeLinkedItem(a) {
      this.linkedItems && this.linkedItems[a] && delete this.linkedItems[a];
    }
  }, {
    key: "detachChild",
    value: function detachChild(a) {
      var b,
          c = this;
      return a === UNDEF ? UNDEF : (c._searchChildren(a, function (a, d, e) {
        e && e.constructor === Array ? b = e.splice(d, 1)[0] : (b = e[a], delete e[a]), b._setLinkedParent(UNDEF), c.fireEvent('childdetached', {
          detachedChild: b
        });
      }), b);
    }
  }, {
    key: "_mapChildren",
    value: function _mapChildren(a, b) {
      b ? _mapSubFnBackward(this.getChildren(), a) : _mapSubFnForward(this.getChildren(), a);
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var a,
          b,
          c,
          d,
          e = this;

      if (e && e !== window && !0 !== e._disposing) {
        if (e._disposing = !0, e.fireEvent('beforeremove'), a = e.getLinkedParent(), a && a.detachChild && !a._disposing && a.detachChild(this.getId()), e._extListeners) for (c in e._extListeners) {
          for (d = e._extListeners[c], b = d.length - 1; 0 <= b; b--) {
            d[b].component && d[b].component.addEventListener && d[b].component.removeEventListener(c, d[b].fn);
          }
        }
        return e.removeAllJobs(), !0;
      }
    }
  }, {
    key: "remove",
    value: function remove(a) {
      var b,
          c = this,
          d = a && a.instant;
      c.setState('removed', !0), b = c.getChildren(), b && c._mapChildren(function (b) {
        b && b.remove && b.remove(a);
      }, !0), d && c._dispose();
    }
  }, {
    key: "setState",
    value: function setState(a, b) {
      this._state[a] = b;
    }
  }, {
    key: "getState",
    value: function getState(a) {
      return this._state && this._state[a];
    }
  }, {
    key: "registerFactory",
    value: function registerFactory(a, b, c) {
      if (this._factoriyNames[a]) for (var _b = 0, _c = this._factories.length, d = !1; _b < _c && !d; _b += 1) {
        this._factories[_b].name === a && (this._factories.splice(_b, 1), d = !0);
      }
      this._factories.push({
        name: a,
        factory: b,
        dep: c
      }), this._factoriyNames[a] = !0;
    }
  }, {
    key: "deregisterFactory",
    value: function deregisterFactory(a) {
      if (this._factoriyNames[a]) return delete this._factoriyNames[a], this._factories.splice(this._factories.findIndex(function (b) {
        return b.name === a;
      }), 1)[0].factory;
    }
  }, {
    key: "invokeFactories",
    value: function invokeFactories() {
      var a,
          b = this,
          c = b._factoriyNames,
          d = {},
          e = b._factories,
          f = e.length + 1,
          g = function g(e) {
        var f;
        e.dep && e.dep.length && e.dep.forEach(function (a) {
          f = c[a] && !d[a];
        }), f ? a.push(e) : (e.factory(b), d[e.name] = !0);
      };

      for (; e.length && e.length < f;) {
        a = [], e.forEach(g), f = e.length, e = a;
      }

      e.length && e.forEach(function (a) {
        return a.factory(b);
      }), this.fireEvent('factoriesinvoked', {});
    }
  }]);

  return ComponentBase;
}();

export default ComponentBase;
export { removeAllEventsFromGraphic, addAllEventsOnGraphic, _mapSubFnForward };